import axiosInstance from 'api/axiosInstance';

export const pinCase = async (
	userID: number,
	caseID: number,
): Promise<void> => {
	const data = {
		userID,
		caseID,
	};
	const response = await axiosInstance.post(
		`/api2.0/pinnedcases/pinCase`,
		data,
	);

	if (response.status !== 200) {
		throw new Error(`Error pinning case`);
	}
};
